import "./modules/wasm/setwasmcallback"
import { wasmModule } from "./modules/wasm/wasmModule"

import {
  CaseZipType,
  ICaseExtInfo,
  ICaseExtraAttr,
  ZipFileList,
  ZipFileName,
} from "./common/types"
import {
  attachmentModule,
  IAttachmentIPRVisible,
} from "./modules/attachment/attachmentModule"
import { boltonModule } from "./modules/bolton"
import { displayModule } from "./modules/displaymodule/displaymodule"
import { initialfinalModule } from "./modules/initialfinal/initialfinalmodule"
import {
  changeArchMode,
  changeArchModeWithMirror,
  clearPreview,
  drawMtcFromZips,
  drawRefinementMtcFromZips,
  drawRefinementSTL,
  drawScanMtc,
  drawSTLWithMirror,
  drawSTLWithoutCanvas,
  fillHole,
  initRefinementView,
  initScanView,
  isInitPreview,
  saveArchType,
  saveDoRefinementStage,
  saveStlToMtc,
  setSTLZoomSize,
  setZoomCallback,
  testInitRefinementView,
  zoomWithValue,
} from "./modules/preview/preview"
import { refinementModule } from "./modules/refinement"
import {
  resourceManager,
  resourcesSynchronization,
} from "./modules/resourcemanager"
import {
  doPresetupWorkflow,
  redoPresetupFlow,
  requestAICloudPresetup,
  requestRefinementPresetup,
} from "./modules/sagemaker/presetup"
import { stagingManager } from "./modules/stagingdatamanager/stagingmanager"
import {
  clearUndoOrRedoState,
  dealWithExistIprOrPAPrompt,
  disPatchButton,
  disPatchPanelDataCallback,
  EToothMoveEventType,
  IToothProperty,
  modificationLogic,
  moveWithInputValue,
  onModificationClicked,
  resetCaseType,
  setIsExistIPROrPAPromptCallback,
  setMoveToothLimitCB,
  setPromptForMovingToothNotOnFinalStageCB,
  setReadonly,
  setRootControl,
  setShowModificationButtonCB,
  setShowToothInfoDialogCB,
  setToothClickedInViewModeCB,
  setToothMoveForbidCB,
  toothModule,
  toothMoveEvent,
  TypeInNumber,
} from "./modules/toothmanager"
import { treatmentPlan } from "./modules/treatmentplan"

import { getArrayFromCPlusArray } from "./common"
import { ESetupType, PanelDataProps } from "./common/commontypes"
import { IAuxullartiesShowInfo } from "./modules/attachment/attachmentModule"

import crc32 from "crc-32"
import JSZip from "jszip"
import { Mi } from "../thirdparts/index"
import { globalEvents, GlobalEvents } from "../utils"
import { report } from "./modules"
import { iprModule } from "./modules/ipr/iprModule"
import { stagingIPRModule } from "./modules/ipr/stagingIPR"
import { relabelModule } from "./modules/relabel"
import { spaceCorrectionModule } from "./modules/spacecorrection/spacecorrection"
import { superimposeModule } from "./modules/superimpose/superimposemodule"
import { EToothDirection } from "./modules/toothmanager/toothdirection"
import {
  isCaninesTeeth,
  isDeciduous,
  isIncisorTeeth,
  isMolarTeeth,
  isPremolarsTeeth,
  isWisdom,
} from "./modules/toothmanager/toothmodule"
import type { EBiteJumpLocationType, HoverToothData } from "./typesofinterface"
export * from "./typesofinterface"

let showMirrorLog = sessionStorage.getItem("ShowMirrorLog")
if (!showMirrorLog) {
  sessionStorage.setItem("ShowMirrorLog", "false")
  showMirrorLog = sessionStorage.getItem("ShowMirrorLog")
}

if (showMirrorLog === "true") {
  Mi.logger.level = Mi.LogLevel.DEBUG
}

function printMetaInfo() {
  // console.log(`WeSmileClinical Version:[${glueLayerPackageJson.version}]`);
}

/**
 *the options of drawRefinementSTL
 */
export interface IDrawRefinementSTLOps {
  upperArch: File | null
  lowerArch: File | null
  zoomRange: [number, number]
}

/**
 * Case life management interface
 */
export const caseManagement = {
  /**
   * init wasm module
   */
  async initWasm(canvas: HTMLCanvasElement, callback?: () => void) {
    await wasmModule.initWASM(canvas, callback)
  },
  /**
   * Don't use 'openCaseOrSwitchCanvas' function, it's a old version
   * please use 'openCaseOrSwitchCanvasWithPromise' instead.
   * in the past,if user want do somthing after opening case. he must use setCallbackAfterOpencase before invoke openCase . now the only await openCaseOrSwitchCanvasWithPromise is enough.
   * @param zipFiles
   *             {
   *                'bulk1.zip': zip File,
   *                'bulk2.zip': zip File，
   *                'bulk3.zip': zip File
   *                'bulk4.zip': zip File
   *                'bulk10.zip': zip File
   *             }
   * @param canvas: HTMLCanvasElement
   * @returns
   */
  async openCaseOrSwitchCanvasWithPromise(
    canvas: HTMLCanvasElement,
    zipFiles: Record<string, Blob> | File | string,
  ) {
    return new Promise((resolve, reject) => {
      caseManagement.openCaseOrSwitchCanvas(canvas, zipFiles, () => {
        resolve(true)
      })
    })
  },
  /**
   * open Case Or Switch Canvas
   * @param canvas
   * @param zipFiles
   * @param callback
   */
  async openCaseOrSwitchCanvas(
    canvas: HTMLCanvasElement,
    zipFiles: Record<string, Blob> | File | string,
    callback?: () => void,
  ) {
    console.log("open case or switch canvas", canvas, zipFiles)
    if (!caseManagement.isCaseInit()) {
      if (callback) {
        caseManagement.setCallbackAfterOpencase(() => {
          callback()
        })
      }
      if (zipFiles instanceof File) {
        caseManagement.openCaseFromZip(canvas, zipFiles)
      } else if (typeof zipFiles === "string") {
        caseManagement.openCaseFromLocalZipFileUrl(canvas, zipFiles)
      } else {
        caseManagement.openCase(canvas, zipFiles)
      }
    } else {
      wasmModule.changeCanvasForWasm(canvas, () => {
        console.log("change canvas!!!")
        if (callback) {
          callback()
        }
        wasmModule.moduleManager.SwitchBiteRampModule(true)
      })
      globalEvents.fire(GlobalEvents.WASM_CANVAS_CHANGED)
    }
  },
  /**
   * Don't use 'openCase' function, it's a old version
   * please use openCaseWithPromise instead.
   * in the past,if user want do somthing after opening case. he must use setCallbackAfterOpencase before invoke openCase . now the only await openCaseWithPromise is enough.
   * @param zipFiles
   *             {
   *                'bulk1.zip': zip File,
   *                'bulk2.zip': zip File，
   *                'bulk3.zip': zip File
   *                'bulk4.zip': zip File
   *                'bulk10.zip': zip File
   *             }
   * @param canvas: HTMLCanvasElement
   * @returns
   */
  async openCaseWithPromise(
    canvas: HTMLCanvasElement,
    zipFiles: Record<string, Blob>,
  ) {
    return new Promise((resolve, reject) => {
      caseManagement.setCallbackAfterOpencase(() => {
        resolve(true)
      })
      caseManagement.openCase(canvas, zipFiles)
    })
  },
  /**
   * open case from patient list
   * zipFiles: the casedata files :
   *             {
   *                'bulk1.zip': zip File,
   *                'bulk2.zip': zip File，
   *                'bulk3.zip': zip File
   *                'bulk4.zip': zip File
   *                'bulk10.zip': zip File
   *             }
   * canvas: HTMLCanvasElement
   */
  async openCase(canvas: HTMLCanvasElement, zipFiles: Record<string, Blob>) {
    printMetaInfo()
    if (!canvas) {
      console.warn("cant opencase, canvas is null ")
      return
    }

    try {
      console.log("** start open case time: ", performance.now(), " ms")
      await new Promise((resolve, reject) => {
        wasmModule.initWASM(canvas, async (module) => {
          console.debug("wasm init over!!!!", canvas, module)
          resolve(true)
        })
      })

      await resourcesSynchronization.clear()
      console.log(
        "** start WriteCaseFilesToVirtualFS: ",
        performance.now(),
        " ms",
      )
      await resourcesSynchronization.writeCaseFilesToVirtualFS(zipFiles)
      console.log(
        "** end WriteCaseFilesToVirtualFS: ",
        performance.now(),
        " ms",
      )
      wasmModule.cancelemloop()
      wasmModule.isPresetup = false
      const windowTitle = document.title
      console.log("** start setup : ", performance.now(), " ms")
      wasmModule.module._setup(wasmModule.module.allocateUTF8(windowTitle))
    } catch (excp) {
      console.warn("open case warning:", excp)
    }
  },

  async AddARefinementHistory(
    zipNames: string[],
    zipFiles: Record<string, Blob>,
  ) {
    const filelist =
      await resourcesSynchronization.turnZipFilesIntoFileDirectory(zipFiles)

    const outFiles: Record<string, Record<string, any>> = {}

    for (let i = 0; i < Object.keys(filelist).length; i++) {
      const fileList2: Record<string, any> = {}
      for (const key of Object.keys(filelist["RetouchHistoryZip" + i])) {
        fileList2["RetouchHistory/" + key] =
          filelist["RetouchHistoryZip" + i][key]
      }

      outFiles[zipNames[i]] = fileList2
    }

    const out = await resourcesSynchronization.makeVirtualDirectory(outFiles)
    await resourcesSynchronization.moduleFS(out)
  },

  IsRefinementItemExisted: (path: CaseZipType) => {
    let pathExited = false
    const pathList =
      resourcesSynchronization.getDirInVituralFS("RetouchHistory")
    for (let i = 0; i < pathList.length; i++) {
      if (pathList[i] === path) pathExited = true
    }

    return pathExited
  },

  IsOldRefinementStructre: () => {
    return resourcesSynchronization.isPathExist(
      "/Setting Data10/RetouchHistory/pathList.txt",
    )
  },

  async openEmptyCase(canvas: HTMLCanvasElement) {
    printMetaInfo()
    if (!canvas) {
      console.warn("cant opencase, canvas is null ")
      return
    }

    await new Promise((resolve, reject) => {
      wasmModule.initWASM(canvas, async (module) => {
        console.debug("wasm init over!!!!", canvas, module)
        resolve(true)
      })
    })
    wasmModule.cancelemloop()
    wasmModule.isPresetup = false
    const windowTitle = document.title
    wasmModule.module._setup(wasmModule.module.allocateUTF8(windowTitle))
  },
  /**
   * open case from local zip
   * @param canvas HTMLCanvasElement
   * zipfile: local zip file
   * @returns
   */
  async openCaseFromZip(canvas: HTMLCanvasElement, zipfile: File) {
    printMetaInfo()
    if (!canvas) {
      console.warn("cant opencase, canvas is null ")
      return
    }

    try {
      await new Promise((resolve, reject) => {
        wasmModule.initWASM(canvas, async (module) => {
          console.log("wasm init over!!!!", canvas, module)
          resolve(true)
        })
      })
      wasmModule.cancelemloop()
      const resFileList = await resourceManager.parseZipFilesFromAZipPacket(
        zipfile,
      )
      const writeFileList = await resourcesSynchronization.makeVirtualDirectory(
        resFileList,
      )
      await resourcesSynchronization.moduleFS(writeFileList)
      caseManagement.setupCase()
    } catch (excp) {
      console.warn("openCaseFromZip::", excp)
    }
  },
  /**
   * Load a prev case from zip
   * zipfile: local zip file
   * @returns
   */
  async loadPrevCaseFromZip(zipfile: File) {
    const resFileList = await resourceManager.parseZipFilesFromAZipPacket(
      zipfile,
    )
    const writeFileList =
      await resourcesSynchronization.makeVirtualDirectoryPrevCase(resFileList)
    await resourcesSynchronization.moduleFSPrevCase(writeFileList)
  },
  /**
   * Load course check scan from stl file
   * stlfile: local stl file
   * @returns
   */
  async uploadCourseCheckScan(stlfile: File, isUpper: boolean) {
    const courseCheckDir = "/test/coursecheck/"
    resourcesSynchronization._mkDirByKeys([courseCheckDir]) // Course check scans are in test/coursecheck folder
    const fileName = courseCheckDir + (isUpper ? "/arch_cc_u." : "/arch_cc_l.")
    for (let i = 0; i < 2; i++) {
      const delFileName = fileName + (i == 0 ? "stl" : "mtc")
      if (wasmModule.module.FS.analyzePath(delFileName).exists)
        wasmModule.module.FS.unlink(delFileName) // delete old scan
    }
    var ext = stlfile.name.split(".").pop().toLocaleLowerCase()
    if (ext !== "stl" && ext !== "mtc") return
    const ab = await stlfile.arrayBuffer()
    const arrayBuffer = new Uint8Array(ab)
    wasmModule.module.FS.writeFile(fileName + ext, arrayBuffer)
  },
  /**
   * open case from local zip
   * @param canvas HTMLCanvasElement
   * @param fileUrl zip file url relate to public dir
   * @returns
   */
  async openCaseFromLocalZipFileUrl(
    canvas: HTMLCanvasElement,
    fileUrl: string,
  ) {
    const fetchRes = async (url) => {
      const resp: Response = await fetch(url, {
        method: "get",
        responseType: "arraybuffer",
      } as any)

      const blob = await resp.blob()
      return blob
    }
    const zipBlob = await fetchRes(fileUrl)
    Object.assign(zipBlob, { lastModifiedDate: new Date(), name: "zipfile" })

    await caseManagement.openCaseFromZip(canvas, zipBlob as File)
  },
  async getCaseFromLocalZip(fileUrl: string) {
    const fetchRes = async (url) => {
      const resp: Response = await fetch(url, {
        method: "get",
        responseType: "arraybuffer",
      } as any)

      const blob = await resp.blob()
      return blob
    }
    const zipBlob = await fetchRes(fileUrl)
    Object.assign(zipBlob, { lastModifiedDate: new Date(), name: "zipfile" })

    const resFileList = await resourceManager.parseZipFilesFromAZipPacket(
      zipBlob as File,
    )

    return resFileList
  },
  /**
   * set callback for open case Finished
   * @param callback
   */
  setCallbackAfterOpencase(callback: () => void) {
    wasmModule.moduleOpenCaseReady = () => {
      if (callback) {
        callback()
      }
    }
  },
  /**
   * when treatment model need enable some modules for initialization
   * @returns
   */
  enableTreatmentModules() {
    wasmModule.moduleManager.SwitchModuleToothEruption(true)
    wasmModule.moduleManager.SwitchModuleMoveTooth(true)
    wasmModule.moduleManager.SwitchUndoOrRedoModule(true)
    wasmModule.moduleManager.SwitchMainWindowModule(true)
    attachmentModule.openAttachmentModule(true)
    wasmModule.moduleManager.SwitchBiteRampModule(true)
  },
  /**
   * close when return back from treatment page.
   */
  closeCase() {
    if (preview.isInitPreview()) preview.clearPreview()
    if (!wasmModule.isFinishedOpencase) return
    disPatchPanelDataCallback()
    wasmModule.delete()
    console.log("close case success")
  },
  setupCase() {
    const windowTitle = document.title
    console.log("start setup........")
    wasmModule.module._setup(wasmModule.module.allocateUTF8(windowTitle))
  },
  /**
   * Is case is finish setup
   * @returns
   */
  isCaseInit() {
    return wasmModule.isFinishedOpencase
  },
  getCaseExtraInfomation() {
    try {
      // get attachment information
      const attachmentReport = attachmentModule.getAttachmentReport()

      let upperTemplate = false
      let lowerTemplate = false
      const attachmentInfo = attachmentReport.attachmentReport
      for (let index = 1; index <= 16; index++) {
        const attachment = attachmentInfo[index]
        if (attachment && attachment.attachment.length > 0) {
          upperTemplate = true
        }
      }
      for (let index = 17; index <= 32; index++) {
        const attachment = attachmentInfo[index]
        if (attachment && attachment.attachment.length > 0) {
          lowerTemplate = true
        }
      }

      // check if there is Ap Attachment
      let apAttachment = false
      const attToothKeys = Object.keys(attachmentReport.attachmentReport)
      const bingoKeys = [6, 5, 4]
      outerLoop: for (const key of attToothKeys) {
        const numKey = Number.parseInt(key, 10)
        const { attachment } = attachmentReport.attachmentReport[numKey]
        if (attachment && attachment.length > 0) {
          for (let n = 0; n < attachment.length; n++) {
            const element = attachment[n]
            if (bingoKeys.includes(element.attachmentId)) {
              apAttachment = true
              break outerLoop
            }
          }
        }
      }
      // get all tooth properties
      const toothList = itoothModule.getToothList()
      const toothProperties: Record<number, IToothProperty> = {}
      for (let index = 0, len = toothList.uplist.length; index < len; index++) {
        const toothId = toothList.uplist[index]
        toothProperties[toothId] = itoothModule.getToothProperties(toothId)
      }
      for (
        let index = 0, len = toothList.lowlist.length;
        index < len;
        index++
      ) {
        const toothId = toothList.lowlist[index]
        toothProperties[toothId] = itoothModule.getToothProperties(toothId)
      }

      let isImplant = false,
        isMissTooth = false,
        isPullout = false,
        isBridge = false,
        isErup = false,
        isBigSpace = false
      const keys = Object.keys(toothProperties)

      for (const key of keys) {
        const numKey = Number.parseInt(key)
        const properties = toothProperties[numKey]
        if (!properties) {
          continue
        }
        if (properties.isBridge) {
          isBridge = true
        }
        if (properties.isImplant) {
          isImplant = true
        }
        if (properties.isErupting) {
          isErup = true
        }
        if (properties.isExtract) {
          isPullout = true
        }
      }

      // check is there a missing tooth?
      // find the tooth id range
      let upperMinToothId = 16
      let upperMaxToothId = 1
      let lowerMinToothId = 32
      let lowerMaxToothId = 16
      for (const key of keys) {
        const toothID = Number.parseInt(key, 10)
        if (toothID <= 16) {
          if (toothID < upperMinToothId) {
            upperMinToothId = toothID
          }
          if (toothID > upperMaxToothId) {
            upperMaxToothId = toothID
          }
        } else {
          if (toothID < lowerMinToothId) {
            lowerMinToothId = toothID
          }
          if (toothID > lowerMaxToothId) {
            lowerMaxToothId = toothID
          }
        }
      }

      for (let i = upperMinToothId; i <= upperMaxToothId; i++) {
        const isExist = keys.includes(i.toString())
        if (!isExist) {
          isMissTooth = true
          break
        }
      }
      for (let i = lowerMinToothId; i <= lowerMaxToothId; i++) {
        const isExist = keys.includes(i.toString())
        if (!isExist) {
          isMissTooth = true
          break
        }
      }

      // check is setup
      let isSetup = false
      let file = resourcesSynchronization.getFileDirectly(
        "teethProperty_u.data",
        "Setting Data2",
      )
      if (!file) {
        file = resourcesSynchronization.getFileDirectly(
          "teethProperty_l.data",
          "Setting Data2",
        )
      }

      if (file) {
        isSetup = true
      }

      const stageData = stagingManager.wasmStageData
      let upperMaxStageNum = 0
      if (stageData.jointUpKeypoints.length > 0) {
        upperMaxStageNum = Number.parseInt(
          stageData.jointUpKeypoints[stagingManager.stageUpnNumber].name,
        )
      }

      let lowerMaxStageNum = 0
      if (stageData.jointLowerKeypoints.length > 0) {
        lowerMaxStageNum = Number.parseInt(
          stageData.jointLowerKeypoints[stagingManager.stageLowNumber].name,
        )
      }

      isBigSpace = wasmModule.mouthModel.GetBigSpace()
      const ret = {
        ApAttachment: apAttachment, // ???判断条件是否是只要有6，5，4号附件存在就为true  在UD中会提示是否有“Button”
        MissTooth: isMissTooth, //  建病例之前没有或者被拔掉就是缺牙
        BigSpace: isBigSpace, // 相邻牙齿间距大于5mm
        Implant: isImplant,
        Pullout: isPullout,
        EruptionDome: isErup ? 1 : 0,
        SetUp: isSetup,
        UpperMaxStageNum: upperMaxStageNum,
        LowerMaxStageNum: lowerMaxStageNum,
        UpperTemplate: upperTemplate ? 1 : 0,
        LowerTemplate: lowerTemplate ? 1 : 0,
        // UpperRetainer: 0, // ??? 魏扬说需要暴露新的接口
        // LowerRetainer: 0, // ??? 魏扬说需要暴露新的接口
        // UpperType: "A", // ??? 需要接口 UD有A/R/I/U WASM只有三种类型
        // LowerType: "A", // ??? 需要接口
        // TimeBeforeSetUp: 0, // ???
        // TimeOnManualSetUp: 0, // ???? 不知道怎么获取
      } as ICaseExtraAttr

      return ret
    } catch (excp) {
      console.error("getCaseExtraInfomation", excp)
      return null
    }
  },
  /**
   * do presetup
   */
  presetupCase(presetupOps) {
    doPresetupWorkflow(
      presetupOps.upperArch,
      presetupOps.lowerArch,
      presetupOps.canvas,
      () => {},
      presetupOps.donecallback,
    )
  },
  /**
   * redo presetup
   */
  redoPresetup(canvas, donecallback) {
    redoPresetupFlow(canvas, () => {}, donecallback)
  },
  /**
   * whole process of presetup is placed in the cloud computing, and get a result zip package
   * @param upper Whether to calculate the upper jaw
   * @param lower Whether to calculate the lower jaw
   * @param orientation Whether to calculate orientation
   * @param caseId caseid
   * @param force force to recalculate
   * @returns
   */
  async requestCloudPresetup(
    upper,
    lower,
    orientation,
    orgId,
    patientId,
    caseId,
    force = false,
    onStartedCallback?: () => void,
  ) {
    return await requestAICloudPresetup(
      upper,
      lower,
      orientation,
      orgId,
      patientId,
      caseId,
      force,
      onStartedCallback,
    )
  },
  /**
   * ai cloud presetup for new refinement
   * @param upper Whether to calculate the upper jaw
   * @param lower Whether to calculate the lower jaw
   * @param orientation Whether to calculate orientation
   * @param caseId caseid
   * @param force force to recalculate
   * @returns
   */
  async refinementPresetup(
    upper,
    lower,
    orientation,
    orgId,
    patientId,
    caseId,
    force = true,
  ) {
    return await requestRefinementPresetup(
      upper,
      lower,
      orientation,
      orgId,
      patientId,
      caseId,
      force,
    )
  },
  /**
   * 获取wasm中保存的扫描照片
   * @returns
   */
  getScansPhoto() {
    return resourcesSynchronization.getScansPhoto()
  },
  /**
   * 获取wasm中InitialFinal截图
   * @returns
   */
  getInitialFinalScreenshot() {
    return resourcesSynchronization.getInitialFinalScreenshot()
  },
  /**
   *  get current case data
   *  if fileName is undefined  then return all files
   *  return file is like :
   *  {
   *     'bulk0.zip': zip File
   *     'bulk2.zip': zip File
   *     'bulk3.zip': zip File
   *     ....
   *  }
   *
   *  else
   *  return a specified file
   *
   * @param fileName it can be undifined,then get the all files.
   *                 it can be a ZipFileName  as 'bulk0' | 'bulk1' | 'bulk2' | 'bulk10' | 'raw' | 'photo'
   *                 it can be a ZipFileList as [ZipFileName] | [ZipFileName,ZipFileName] ...
   *
   */
  async getCaseFiles(fileName?: ZipFileList | ZipFileName) {
    const zipList = await resourcesSynchronization.saveAndGetFileZips(fileName)

    // set uploaded status for each setting data folder
    if (wasmModule.statusController) {
      for (const key in zipList) {
        if (!key.includes("bulk")) continue
        const folderName = key
          .replace("bulk", "Setting Data")
          .replace(".zip", "")
        wasmModule.statusController.OnUploadFolder(folderName)
        console.log(`- - - set ${folderName} as uploaded`)
      }
    }

    return zipList
  },

  async verifyZip(blob: Blob) {
    const arrayBuffer = await blob.arrayBuffer()
    const zip = await JSZip.loadAsync(arrayBuffer)

    for (const [fileName, zipFile] of Object.entries(zip.files)) {
      if (zipFile.dir) continue // 跳过文件夹  skip directories

      // 解压文件 decompress file
      const content = await zipFile.async("uint8array")

      // 计算 CRC32  compute CRC32
      const computedCRC = crc32.buf(content) >>> 0
      const storedCRC = zipFile._data.crc32 >>> 0

      // console.log(
      //   `${fileName} | stored CRC=${storedCRC.toString(
      //     16,
      //   )} | computed CRC=${computedCRC.toString(16)}`,
      // )

      if (computedCRC !== storedCRC) {
        console.error(`❌ CRC mismatch: ${fileName}`)

        return {
          crcValid: false,
          message: ` ${fileName}: is corrupted (CRC mismatch)`,
        }
      }
    }

    return {
      crcValid: true,
      message: "All files are valid.",
    }
  },

  /**
   * 保存后获取所有文件用以上传
   * @param fileName
   * @returns
   */
  async getRefinementZipFiles(refinementNames: string[]) {
    //let caseDirs=[];
    //caseDirs.push("bulk10");
    //caseDirs.push("bulk2");
    //let files=this.getCaseFiles(caseDirs);

    let dirFiles: Record<string, Record<string, File>> = {}
    for (let i = 0; i < refinementNames.length; i++) {
      let files = await resourcesSynchronization.getFileListFromVirtualFS(
        "RetouchHistory/" + refinementNames[i],
      )

      const files2: Record<string, File> = {}
      for (const f in files) {
        let newKey = f.substring(15, f.length)
        files2[newKey] = files[f]
      }

      dirFiles[refinementNames[i]] = files2
    }

    let zipFiles = await resourcesSynchronization.zipFileListFromVirtualFS(
      dirFiles,
    )

    const jsonFile = new File(
      [
        await wasmModule.module.FS.readFile(
          "/test/case/RetouchHistory/RetouchHistory.json",
        ),
      ],
      "RetouchHistory.json",
      {
        type: "application/json",
        lastModified: Date.now(),
      },
    )
    zipFiles["RetouchHistory.json"] = jsonFile

    return zipFiles
  },
  /**
   * get AttachmentReport and IPRReport
   * @param val
   * @returns
   */
  getAttachmentIPRReport(getHisReport: boolean = false) {
    const attachment = attachmentModule.getAttachmentReport(getHisReport)
    const iprReport = iprModule.getIPRReport(getHisReport)
    const reportData = {
      attachment: attachment.attachmentReport,
      toothlist: attachment.toothList,
      firstStage: attachment.firstStage,
      ipr: iprReport,
    }
    return reportData
  },
  /**
   * get bolton report data
   */
  getBoltonReport(getHisReport: boolean = false) {
    boltonModule.computeBolton(getHisReport)
    return boltonModule.getBoltonReport()
  },
  /**
   * get AttachmentVisible and IPRVisible
   * @returns
   */
  getAttachmentIPRData() {
    const visible: IAttachmentIPRVisible = {
      isHasAttachmentData: wasmModule.statusController.IsAddAttachment(),
      isHasIPRData: wasmModule.statusController.HasCollision(),
    }
    return visible
  },

  getIsHasIPRNode() {
    return wasmModule.statusController.IsHasIPRNode()
  },
  /**
   * get Case Setup Type
   * @returns
   */
  getCaseSetupType() {
    return wasmModule.caseSetupType
  },
  /**
   * set Case Setup Type
   * @returns
   */
  setCaseSetupType(type: ESetupType) {
    wasmModule.caseSetupType = type
  },
  /**
   * Complete Attachments Automatically
   * @param callback
   * @returns
   */
  setcalsetupfinishCallback(callback: () => void) {
    wasmModule.calsetupfinishCallback = callback
  },

  //------------------ Treatment plan ---------------------
  /**
   * set or get case extra information , it's a json object
   * please confirm that the caseExtInfo has been set before using other treatment-plan interface.
   * @returns CaseExInfo JSON obj
   */
  setCaseExtInfo(caseExtInfo: ICaseExtInfo) {
    treatmentPlan.setCaseExtInfo(caseExtInfo)
  },
  getCaseExtInfo() {
    return treatmentPlan.caseExtInfo
  },
  /**
   * Get treatment plan name list
   * notice: please confirm that the caseExtInfo has been set before using this interface. if not it'll throw a error.
   * @returns the name list of treatment plans.
   */
  getTreatmentPlanList() {
    return treatmentPlan.getTxNameList()
  },
  /**
   * get tx plan data is changed or not;
   * @returns
   */
  getTxDataChanged() {
    return treatmentPlan.getTxDataChanged()
  },
  /**
   * get tx plan data is changed or not;
   * @returns
   */
  setTxDataChanged(changed) {
    treatmentPlan.setTxDataChanged(changed)
    if (stagingManager.setTxPlanDataChangedCallBack) {
      stagingManager.setTxPlanDataChangedCallBack()
    }
  },
  /**
   * add new treatment plan
   * @returns
   */
  addTreatment(addType) {
    return treatmentPlan.addTx(addType)
  },
  /**
   * Change to target tx
   * notice: please confirm that the caseExtInfo has been set before using this interface. if not it'll throw a error.
   * if target tx name equle current tx , nothing's gonna happen .
   * @param txIndex  1 | 2   the txPlan of which treatment to changed into.
   * @returns
   */
  changeTreatment(txIndex: 1 | 2) {
    return treatmentPlan.changeTx(txIndex)
  },
  /**
   * rename a exist treatment plan
   * notice: please confirm that the caseExtInfo has been set before using this interface. if not it'll throw a error.
   * @param txIndex: 1 | 2   the txPlan to be rename
   * @param newName new name
   * @returns
   */
  renameTreatment(txIndex: 1 | 2, newName: string) {
    return treatmentPlan.renameTx(txIndex, newName)
  },
  /**
   * Save current Tx
   * notice: please confirm that the caseExtInfo has been set before using this interface. if not it'll throw a error.
   * @param saveData
   * @returns
   */
  saveCurrentTx(saveData: boolean) {
    return treatmentPlan.saveCurrentTx(saveData)
  },
  /**
   * Del a Treatment Plan
   * @param txIndex
   * @returns
   */
  delTx(txIndex: 1 | 2) {
    return treatmentPlan.delTx(txIndex)
  },
  /**
   * get reports for tooth movement table
   * @param isUpper
   * @returns
   */
  getToothReports(
    isUpper: boolean,
    getHisReport: boolean = false,
  ): Map<number, any> {
    report.update(getHisReport)
    return isUpper ? report.UpReportArrays : report.LowReportArrays
  },
  /**
   * set mainpage's background color
   * @param r
   * @param g
   * @param b
   * @returns
   */
  setBackgroundColor(r: number, g: number, b: number) {
    if (!wasmModule.isFinishedOpencase) return
    wasmModule.ulabwinIns.setBackgroundColor(r, g, b)
  },
  /**
   * set background picture,Just pass in the full file name of the image
   * @param url 图片存储在resource/Pictures/下
   * @returns
   */
  setBackgroundPic(url: string) {
    if (!wasmModule.isFinishedOpencase) return
    wasmModule.ulabwinIns.setBackgroundPic(url)
  },
  /**
   * Setting the gradient background color
   * @param color1 hexadecimal color
   * @param color2 hexadecimal color
   * @returns
   */
  SetBackgroundGradient(color1: string, color2: string) {
    if (!wasmModule.isFinishedOpencase) return
    wasmModule.ulabwinIns.SetBackgroundGradient(color1, color2)
  },
  /**
   * get the archs is exist
   * @returns
   */
  getHasArchType() {
    const archsType = {
      hasUpperArch: false,
      hasLowerArch: false,
    }
    const jsonFile = resourcesSynchronization.getFileByPathname(
      "/test/case/Setting Data2/ArchType.json",
    )
    return new Promise((resolve, reject) => {
      const reader = new FileReader()

      reader.onload = (event) => {
        const result = event.target.result as string
        const archJson = JSON.parse(result)
        if ("upArch" in archJson) archsType.hasUpperArch = true
        if ("downArch" in archJson) archsType.hasLowerArch = true

        resolve(archsType)
      }

      reader.onerror = (event) => {
        reject(event.target.error)
      }

      reader.readAsText(jsonFile)
    })
  },
  /**
   * save json data to zip
   * @param data jsondata
   * @param fileName fimename
   * @param url
   * @returns
   */
  saveJsonDataToZip: async (
    data: string,
    fileName: string,
    path: CaseZipType,
  ) => {
    if (!wasmModule.module) return false

    const saveRes = await resourcesSynchronization.saveJsonDataToZip(
      data,
      fileName,
      path,
    )

    return saveRes
  },
  /**
   * save photo to zip
   * @param photo
   * @param fileName fimename
   * @returns
   */
  savePhotoToZip: async (photo: File, fileName: string) => {
    if (!wasmModule.module) return false
    const saveRes = await resourcesSynchronization.saveFileToZip(
      photo,
      fileName,
      "Photo",
    )
    return saveRes
  },
  /**
   *
   * @param stl: STL file
   * @param isUpper: upper or lower
   * @returns
   */
  saveStlToZip: async (stl: File, isUpper: boolean) => {
    if (!wasmModule.module) return
    let stlFilePath: Record<string, any> = {}
    const stlPath = isUpper ? "test/pre/arch_u.stl" : "test/pre/arch_l.stl"
    stlFilePath[stlPath] = stl
    let result = await resourcesSynchronization.moduleFS(stlFilePath)
    const mtcPath = isUpper ? "Raw/arch_o_u.mtc" : "Raw/arch_o_l.mtc"
    wasmModule.module.SaveMtcFileToFolder(stlPath, mtcPath)
    return result
  },
  /**
   * read all photos from zip
   * @param photo
   * @param fileName fimename
   * @returns
   */
  getPhotoFromZip: async (fileName: string) => {
    if (!wasmModule.module) return false
    const blob: Blob = await resourcesSynchronization.getFileFromZip(
      fileName,
      "Photo",
    )
    const file: File = new File([blob], fileName, {
      type: "image/png",
    })
    return file
  },
  /**
   * read all photos from zip
   * @param photo
   * @param fileName fimename
   * @returns
   */
  getPhotoListFromZip: () => {
    if (!wasmModule.module) return []
    return resourcesSynchronization.getFileListFromZip("Photo")
  },
  /**
   * set on report data update callback
   * @returns
   */
  setOnReportUpdateCB(callback: (reportsData) => void) {
    globalEvents.on(GlobalEvents.ON_REPORT_UPDATE, () => {
      const data = this.getAttachmentIPRReport()
      callback(data)
    })
  },
  /**
   *  Storing the start stage for doing a refinement,
   *  '-1010' means no refinement for upper or lower.
   * @param upperStage
   * @param lowerState
   * @returns
   */
  async saveDoRefinementStage(upperStage: any, lowerState: any) {
    if (!wasmModule.isWASMInit) return false

    const parasData = {
      upperTPStep: Number.parseInt(upperStage),
      lowerTPStep: Number.parseInt(lowerState),
    }

    const jsonData = JSON.stringify(parasData, (key, value) => {
      // 如果值是数字，不添加引号
      return typeof value === "number" ? value : value
    })
    console.log("ashuaizzz🚀 ~save refinement stage jsonData:", jsonData)

    const blob = new Blob([jsonData], { type: "text/plain" })
    const file = new File([blob], `case/Setting Data10/refinement/paras.json`)
    const savePath: Record<string, any> = {}
    savePath[`test/case/Setting Data10/refinement/paras.json`] = file

    const saveRes = await resourcesSynchronization.moduleFS(savePath)
    return saveRes
  },

  setActualIPRValue(IPRValuesStr: string): boolean {
    return iprModule.setActualIPRValue(IPRValuesStr)
  },

  setIPRMessage(IPRMessage: string): boolean {
    return iprModule.setIPRMessage(IPRMessage)
  },

  getIPRMessage(): string {
    return iprModule.getIPRMessage()
  },
}
/**
 * Interfaces of Stage controling
 */
export const stageControl = {
  /**
   * get wasm stage data
   * @returns
   */
  getWasmStageData() {
    return stagingManager.wasmStageData
  },
  /**
   * set stage value from UI
   * @param upstep
   * @param lowstep
   */
  setStageStep(upstep, lowstep) {
    stagingManager.setStageStep(upstep, lowstep)
  },
  /**
   * give notice to UI when current stage number change
   * @param arch
   * @param index
   */
  setStageCallback(callback) {
    stagingManager.setStageCallback = callback
  },
  /**
   * give notice to UI when Setup Type
   * @param callback
   * @returns
   */
  setSetupTypeCaseCallback(callback) {
    stagingManager.setupTypeAndStage = callback
    // attachmentModule.iprVisibility = callback;
  },
  /**
   * get count of KeyPoints ,return which is larger between upper and lower.
   * if the max number is 8,It means there are 9 steps
   * @returns
   */
  getMaxStageNodeIndex(): number {
    return Math.max(
      stagingManager.wasmStageData.keypointsUpMaxStep,
      stagingManager.wasmStageData.keypointsDownMaxStep,
    )
  },
  /**
   * get the current stage index
   * @returns
   */
  getCurrentStageIndex(): { upper: number; lower: number } {
    const ret = stagingManager.getCurrentStageIndex()
    return ret
  },
  /**
   * switch step between Initial and current
   */
  switchIC() {
    let upIndex = 0
    let lowerIndex = 0
    const curUpNodeIndex = stagingManager.wasmStageData.curUpNodeIndex
    const curLowerNodeIndex = stagingManager.wasmStageData.curLowerNodeIndex
    if (
      (curUpNodeIndex === 0 || curUpNodeIndex === -1) &&
      (curLowerNodeIndex === 0 || curLowerNodeIndex === -1)
    ) {
      if (stagingManager.lastNoZeroUpIndex !== 0) {
        upIndex = stagingManager.lastNoZeroUpIndex
      }
      if (stagingManager.lastNoZeroLowerIndex !== 0) {
        lowerIndex = stagingManager.lastNoZeroLowerIndex
      }
    }

    stagingManager.setStageStep(upIndex, lowerIndex)
  },
  /**
   * set BiteJump Type
   * @param biteJumpType
   * @returns
   */
  setBiteJumpType(biteJumpType: EBiteJumpLocationType) {
    stagingManager.SetBiteJumpType(biteJumpType)
  },
  /**
   * 获取下颌是否做过bite jump
   * @returns
   */
  isDownArchBiteMoved() {
    if (!wasmModule.isFinishedOpencase) return false
    return wasmModule.stagingcontoler.IsDownArchBiteMoved()
  },
  /**
   * play GM animation
   * @returns
   */
  playGMAnimation() {
    if (!wasmModule.isFinishedOpencase) return 0
    return wasmModule.stagingcontoler.playGMAnimation()
  },
  /**
   * set biteJump type and play GM
   * @param biteJumpType
   * @returns
   */
  setBiteJumpTypePlayGM(biteJumpType: EBiteJumpLocationType) {
    if (!wasmModule.isFinishedOpencase) return
    wasmModule.stagingcontoler.setBiteJumpTypePlayGM(biteJumpType)
  },
  /**
   * get biteJump type
   * @returns
   */
  getBiteJumpType() {
    if (!wasmModule.isFinishedOpencase) return 0
    return wasmModule.stagingcontoler.getBiteJumpType()
  },
  /**
   * add more stage
   * @param archType 0, 1
   * @param addMore true, false
   * @returns
   */
  SetAddMoreFoFinalStage(archType: number, addMore: boolean) {
    wasmModule.stagingcontoler?.SetAddMoreFoFinalStage(archType, addMore)
  },
  SetDefaultDegreeAndSpace(degree: number, space: number): void {
    if (degree === undefined || space === undefined) return
    wasmModule.stagingcontoler?.ChangeDefaultDegreeAndSpace(degree, space)
  },

  /**
   * get is in quick3
   * @returns
   */
  isInQuick3() {
    if (!wasmModule.isFinishedOpencase) return false
    return wasmModule.stagingcontoler.isInQuick3()
  },

  switchICForCompare(viewIndex: number): { upper: number; lower: number } {
    if (viewIndex > 1 || viewIndex < 0) return
    let upIndex = 0
    let lowerIndex = 0
    const curUpperIndex = stagingManager.curIndexForCompare[viewIndex][0]
    const curLowerIndex = stagingManager.curIndexForCompare[viewIndex][1]
    if (curUpperIndex === 0 && curLowerIndex === 0) {
      if (stagingManager.lastNoZeroIndexForCompare[viewIndex][0] !== 0) {
        upIndex = stagingManager.lastNoZeroIndexForCompare[viewIndex][0]
      }
      if (stagingManager.lastNoZeroIndexForCompare[viewIndex][1] !== 0) {
        lowerIndex = stagingManager.lastNoZeroIndexForCompare[viewIndex][1]
      }
    }

    stagingManager.updateCompareStageIndex(viewIndex, upIndex, lowerIndex)
    treatView.PlayFrame(viewIndex, Math.max(upIndex, lowerIndex))
    return { upper: upIndex, lower: lowerIndex }
  },
}

/**
 * Interfaces of Initial-final
 */
export const initialfinal = {
  /**
   * 打开或者关闭initialfinal窗口
   * @param isEnable
   */
  setInitialFinalEnabled: (isOpen) => {
    initialfinalModule.switchInitialFinalDisplayModule(isOpen)
  },
  /**
   * 前端传入的zoom缩放值
   * @param scaleFac
   * @returns
   */
  zoomByScale(scaleFac) {
    initialfinalModule.zoomByUI(scaleFac)
  },
  /**
   * 鼠标滚轮滑动时回调给前端当前的zoom缩放值(每次重新打开initialfinal模块都需要调用)
   * @param callback
   * @returns
   */
  setZoomInitialFinalCallback(callback) {
    initialfinalModule.setUpdateSliderCB(callback)
  },
  /**
   * 当打开initialfinal窗口后再点击occlusal按钮后调用
   * @returns
   */
  openOcclusalView() {
    initialfinalModule.openOcclusalView()
  },
}

export const preview = {
  /**
   * size range is betweeen 0.1 and 2
   * @param numScale
   * @returns
   */
  setSTLZoomSize,
  /**
   * draw STL with Mirror
   * @param drawSTLOps
   * @returns
   */
  drawSTLWithMirror,
  /**
   * draw STL without canvas
   */
  drawSTLWithoutCanvas,
  /**
   *changeArchMode
   *param name  (1、up.2、low.3、both)
   */
  changeArchMode,
  /**
   * zoom with scale
   * @param scale
   */
  zoomWithValue,
  /**
   * setup zoom callback
   * @param zoomRange  the [min,max] tuple value of the scale
   * @param callback  (val: number) => void)
   */
  setZoomCallback,
  /**
   * clear the preview after quit thie prewpage
   */
  clearPreview,
  /**
   * Convert stl to mtc file
   * Called when you click next after uploading the stl
   * @param upperStl
   * @param lowerStl
   * @param isRefinement Whether it is a case of refinement
   */
  saveStlToMtc,
  /**
   * Returns whether the preview has been initialized
   */
  isInitPreview,
  /**
   * Loading mtc files from zips in preView page
   * @param zips  zip lists: `bulk0`,`bulk1` ,`bulk2` ,`bulk10` ,`photo` ,`raw ` ,`storage.version.json.zip`
   * @param zoomRange [min sacle number, max scale number]  [0.25,2.0] is the default
   */
  drawScanMtc,
  /**
   * Loading mtc files from zips in preView page
   * @param zips  zip lists: `bulk0`,`bulk1` ,`bulk2` ,`bulk10` ,`photo` ,`raw ` ,`storage.version.json.zip`
   * @param zoomRange [min sacle number, max scale number]  [0.25,2.0] is the default
   */
  drawMtcFromZips,
  /**
   * 初始化 scan / preview view
   * @param canvas
   * @param zips
   */
  initScanView,
  /**
   * 初始化refinement view
   * @param canvas
   * @param zips
   */
  initRefinementView,
  /**
   * just using in glue layer
   * @param canvas
   * @param zip
   * @returns
   */
  testInitRefinementView,
  /**
   * draw refinement stl in preview
   * @param drawSTLOps
   * @returns
   */
  drawRefinementSTL,
  /**
   * Loading refinement mtc files from zips in preView page
   * @param zips  zip lists: `bulk0`,`bulk1` ,`bulk2` ,`bulk10` ,`photo` ,`raw ` ,`storage.version.json.zip`
   * @param zoomRange [min sacle number, max scale number]  [0.25,2.0] is the default
   */
  drawRefinementMtcFromZips,
  /**
   * save upper or lower archType
   * @param upper
   * @param lower
   * @returns
   */
  saveArchType,
  /**
   * Storing the start stage for doing a refinement,
   * '-1010' means no refinement for upper or lower.
   * @param upperStage
   * @param lowerState
   * @returns
   */
  saveDoRefinementStage,
  /**
   * fill hole is a preprocessing
   */
  fillHole,
  /**
   * change ArchMode With Mirror
   * @param drawSTLOps
   * @returns
   */
  changeArchModeWithMirror,
}

export const toothTools = {
  isIncisorTeeth,
  isCaninesTeeth,
  isPremolarsTeeth,
  isMolarTeeth,
  /**
   * 是否是智齿
   */
  isWisdom,
  /**
   * 是否是多生牙
   */
  isDeciduous,
}

/**
 * Interfaces of Treatment
 */
export const viewControlInTreatment = {
  /**
   * set attachment is visibility?
   * @param isVisible boolean
   * @returns
   */
  setAttachmentVisibility(isVisible) {
    if (!wasmModule.isFinishedOpencase) return
    wasmModule.statusController.DisplayAttachment(isVisible)
    wasmModule.moduleManager.GetBiteRampModule()?.SetBiteRampVisiable(isVisible)
    //  if (!this.wasmAttachmentModule) {
    attachmentModule.wasmAttachmentModule =
      wasmModule.moduleManager.GetAttachmentModule()
    //   }
  },
  /**
   * draw auxullarties animation in a canvas
   * @param canvasElement canvas element
   * @param auxinfoList auxinfo include the info of aux and the element where to draw it.
   *  interface IAuxullartiesShowInfo {
   *    //  aux type
        type: "Normal" | "PressurePoint" | "ButtonAndSlits";
        //  [auxId,the dom element where we draw the aux]
        elements: [string, HTMLElement][];
      }
      因为canvas.style.transform属性默认会跟随canvasElement的scrollTop属性，以跟随滑动，
      且canvas.stype.position = 'absolute'
      canvasElement的position属性，必须为'absolute'或者'relative',否则跟随会有问题。
      另外canvas.stype.z-index= '1' ，注意图层排序。

   * @returns
   */
  drawAuxullarties(
    canvasElement: HTMLElement,
    auxinfoList: IAuxullartiesShowInfo[],
  ) {
    attachmentModule.drawAuxullarties(canvasElement, auxinfoList)
  },
  /**
   * setZoomCallbackInTreatment
   * it will be invoked on mouse wheel change
   * @param callback (scalevalue: number) => void
   * @returns
   */
  setZoomCallbackInTreatment(callback) {
    displayModule.setZoomCallback([0.25, 4.0], callback)
  },
  /**
   * zoomWithValueInTreatment
   * @param val  the scale value.default is 1.0
   * @returns
   */
  zoomWithValueInTreatment(val) {
    displayModule.zoomWithValue(val)
  },
  /**
   * show upper arch or lower
   * @param mode  'up' | 'low' | 'all'
   * @returns
   */
  showArchMode(mode) {
    displayModule.showArchMode(mode)
  },
  /**
   * set the view type
   * @param type 'left' | 'right' | 'front'|'back' | 'split'
   * @returns
   */
  setViewType(type) {
    switch (type) {
      case "left":
        displayModule.splitScreenDisplay(false)
        displayModule.setToLeftBuccalView()
        break
      case "right":
        displayModule.splitScreenDisplay(false)
        displayModule.setToRightBuccalView()
        break
      case "back":
        displayModule.splitScreenDisplay(false)
        wasmModule.statusController.SetToBackView()
        break
      case "front":
        displayModule.splitScreenDisplay(false)
        displayModule.setToAnteriorView()
        break
      case "split":
        displayModule.splitScreenDisplay(true)
        // 处理inside视窗ipr显示问题
        iprModule.updateIPRVisibility()
        break
      default:
        break
    }
    displayModule.setShowType(type)
  },
  /**
   * set IPR is visibile
   * @param val
   * @returns
   */
  setIPRVisibility(isVisible, stageIndexForShow = 0) {
    if (!wasmModule.isFinishedOpencase) return
    iprModule.setIPRVisibility(isVisible, stageIndexForShow)
  },
  /**
   * set Grid is visibile
   * @param val
   * @returns
   */
  setGridVisibility(isVisible: boolean) {
    if (!wasmModule.isFinishedOpencase) return
    // wasmModule.moduleManager.SetGridActorsColor(
    //   120 / 255,
    //   144 / 255,
    //   156 / 255,
    //   0.5,
    //   120 / 255,
    //   144 / 255,
    //   156 / 255,
    //   0.5,
    //   120 / 255,
    //   144 / 255,
    //   156 / 255,
    //   1
    // );
    wasmModule.wrapInstance.ShowGridLayer(isVisible)
  },

  /**
   * set Super-impose Stage
   * @param val
   * @returns
   */
  setSuperimposeStage(isUpper: boolean, step: number) {
    if (!wasmModule.isFinishedOpencase) return
    superimposeModule.SetSuperimposeStage(isUpper ? 0 : 1, step)
  },

  /**
   * set Super-impose visibility
   * @param isVisible
   * @returns
   */
  setSuperimposeVisibility(isVisible: boolean) {
    if (!wasmModule.isFinishedOpencase) return
    superimposeModule.ShowSuperimpose(isVisible)
  },

  /**
   * set Super-impose Opacity
   * @param isVisible
   * @returns
   */
  setSuperimposeOpacity(opacityVal: number) {
    if (!wasmModule.isFinishedOpencase) return
    superimposeModule.SetSuperimposeOpacity(opacityVal)
  },

  /**
   * set Occlusion is Visible
   * @param isVisible
   */
  setOcclusionVisibility(isVisible: boolean) {
    if (!wasmModule.isFinishedOpencase) return
    if (isVisible) wasmModule.statusController.TurnOnBiteCheck()
    else wasmModule.statusController.TurnOffBiteCheck()
  },

  /**
   * set space check is Visible
   * @param isVisible
   */
  setSpacecheckVisibility(isVisible: boolean) {
    if (!wasmModule.isFinishedOpencase) return
    wasmModule.wrapInstance.ShowCollision(isVisible)
  },
  /**
   * set Overlay is Visible
   * @param isVisible
   * @returns
   */
  setOverlayVisibility(isVisible: boolean) {
    displayModule.switchOverlayModule(isVisible)
  },
  /**
   * set Overlay opacity
   * @param opacity  from 0 to 1
   * @returns
   */
  setOverlayOpacity(opacity: number) {
    displayModule.opacityOverlay(opacity)
  },

  /**
   * 特殊牙齿颜色开关
   * @param isEnable
   * @returns
   */
  specialToothColorToggle(isEnable: boolean) {
    if (!wasmModule.isFinishedOpencase) return

    wasmModule.statusController.SetEnableToothColorSetting(isEnable)
  },

  /**
   * 设置 Dome/Tooth display switch
   * if toothId is 0, it means user picked on dome without tooth
   */
  setDomeDisplayCallback(
    cb: (
      isVisible: boolean,
      toothID: number,
      x: number,
      y: number,
      isRight: boolean,
      isUpper: boolean,
    ) => void,
  ) {
    ;(window as any).showDomeDisplayCB = cb
    wasmModule.moduleManager.SetShowPickModeDialogCBForDome("showDomeDisplayCB")
  },

  /**
   * 调用Dome Sync button 功能
   * 在最后一步，第一步，移动dome后，正常播放dome会动。点击这个按钮后，再播放，dome位置不变。
   * @returns
   */
  makeDomeStatic() {
    const mteModule = wasmModule.moduleManager.GetModuleToothEruption()
    if (mteModule) {
      mteModule.OnSyncButtonDown()
    }
  },

  /**
   * to change between Picking demo or picking tooth
   * @param isPickDome
   */
  changePickDomeMode(isPickDome: boolean) {
    const mteModule = wasmModule.moduleManager.GetModuleToothEruption()
    if (mteModule) {
      mteModule.ChangePickDomeMode(isPickDome)
    }
  },
  /**
   * 设置显示pontic dome 菜单的回调函数
   * @param cb
   * @returns
   */
  setShowDomePonticSelectionMenuCallback: (cb: (data) => void) => {
    ;(window as any).ShowDomePonticSelectionMenu = cb
  },
  /**
   * 设置隐藏pontic dome 菜单的回调函数
   * @param cb
   * @returns
   */
  setHidenDomePonticSelectionMenuCallback: (cb: () => void) => {
    ;(window as any).HidenDomePonticSelectionMenu = cb
  },
  /**
   * 设置显示提示call back，当操作pontic dome时
   * @param cb
   * @returns
   */
  setPromptHandleDomePonticCallback: (cb: (promptType) => void) => {
    ;(window as any).PromptHandleDomePontic = cb
  },
  /**
   * 点击添加Pontic Dome
   * @param toothid 点击的牙齿id
   * @param operatID 点击的 operatID
   * @returns
   */
  AddPonticDome(toothid: number, operatID: number) {
    const mteModule = wasmModule.moduleManager.GetModuleToothEruption()
    if (mteModule) {
      mteModule.AddPonticDome(toothid, operatID)
    }
  },
  /**
   * 点击删除Pontic Dome
   * @param toothid 点击的牙齿id
   * @returns
   */
  DelPonticDome(toothid: number) {
    const mteModule = wasmModule.moduleManager.GetModuleToothEruption()
    if (mteModule) {
      mteModule.DelPonticDome(toothid)
    }
  },
  /**
   * 设置显示static dome 按钮的回调函数
   * @param cb
   * @returns
   */
  setUpdateDomeSyncBtnStatusCallback: (
    cb: (bShow: boolean, isLocked: boolean, posX: number, posY: number) => void,
  ) => {
    ;(window as any).UpdateDomeSyncBtnStatus = cb
  },
  /**
   * 设置仅仅能再kayframe上移动dome的回调函数，回调之后弹出提示框
   * @param cb
   * @returns
   */
  setPromptOnlyCanBeModifiedOnKeyFramesCallback: (cb: () => void) => {
    ;(window as any).PromptOnlyCanBeModifiedOnKeyFrames = cb
  },
  /**
   * static dome 按钮的处理函数
   * @param cb
   * @returns
   */
  OnSyncButtonDown() {
    const mteModule = wasmModule.moduleManager.GetModuleToothEruption()
    if (mteModule) {
      mteModule.OnSyncButtonDown()
    }
  },
  /**
   * 鼠标悬浮在牙齿上返回牙齿的相关信息
   * @param callback
   * @returns
   */
  setHoverToothCallback: (callback: (hoverData: HoverToothData) => void) => {
    displayModule.setHoverToothcallback(callback)
  },
  /* hover tooth 开关
   * @param isEnable
   * @returns
   */
  hoverToothToggle: (isEnable: boolean) => {
    displayModule.setHoverToothToggle(isEnable)
  },
  /**
   * Split the sceen to two parts,the upper part is the upper orch and the lower part is the lower arch
   * @param isSplit
   */
  splitWindowToUpperAndLower: (isSplit: boolean) => {
    if (wasmModule) {
      wasmModule.statusController?.HorizontalSplitScreen(isSplit)
    }
  },
}

/**
 * 待修改，目前定义较难理解，把计算流程给暴露出来让前端统一来串
 * 只定义三个接口 设置callback ,调预计算判断是否弹框接口，计算接口。
 */
export const toothMovement = {
  /**
   * 当移牙做了PA(passive aligner) 或者 IPR 需要提示用户是否除去PA和IPR
   * 回调函数的参数: (hasIPR:0|1,hasPA:0|1)=>void
   */
  setIsExistIPROrPAPromptCallback(
    callback: (hasIPR: 0 | 1, hasPA: 0 | 1) => void,
  ) {
    setIsExistIPROrPAPromptCallback(callback)
  },
  /**
   * 用户选择确认或取消需要调用此接口通知WASM,
   * 确认则删除PA和IPR，取消则什么都不做。
   * @param confirmOrCancel
   * @returns
   */
  dealWithExistIprOrPAPrompt(comfirmOrCancel: boolean) {
    dealWithExistIprOrPAPrompt(comfirmOrCancel)
  },
  /**
   *  关闭/打开移牙功能
   * @param isEnabled
   * @returns
   */
  setIsEnableMoveTooth(isEnabled: boolean) {
    wasmModule.moduleManager.SwitchModuleMoveTooth(isEnabled)
  },
  /**
   *  获取当前是否可以移牙
   * @param callback  (isAllow:boolean)=>void
   * @returns
   */
  getIsAllowMoveTooth(callback) {
    const windowObj = window as any
    windowObj.toothNotAllowMoveCallback = callback
  },
  /**
   *  获取当前选中牙齿是否为锁定状态
   * @returns true:锁定 false:未锁定
   */
  getToothLockState() {
    if (!wasmModule.isFinishedOpencase) return false
    const moveToothModule = wasmModule.wrapInstance.GetMoveToothModule()
    if (!moveToothModule) return false
    if (moveToothModule.GetPickedToothId() === -1) return false
    return moveToothModule.GetToothLockStatus(
      moveToothModule.GetPickedToothId(),
    )
  },
  /**
   *  锁定当前状态的牙齿move功能
   * @param isEnabled
   * @returns
   */
  lockMoveTooth(isLock) {
    const moveToothModule = wasmModule.wrapInstance.GetMoveToothModule()
    moveToothModule.LockTooth(moveToothModule.GetPickedToothId(), isLock)
  },
  /**
   * reset tooth movement
   * @returns
   */
  resetToothMovement() {
    const moveToothModule = wasmModule.wrapInstance.GetMoveToothModule()
    moveToothModule.ResetToothMovement()
  },
  /**
   *  拔掉当前选中牙齿/恢复拔掉的牙齿
   * @param id：恢复的牙齿id,不传参：拔掉选中的牙齿
   * @returns
   */
  pulloutATooth(id?) {
    const moveToothModule = wasmModule.wrapInstance.GetMoveToothModule()
    if (id) {
      moveToothModule.PulloutATooth(id)
    } else {
      moveToothModule.PulloutATooth(moveToothModule.GetPickedToothId())
    }
    ;(window as any).pulloutCallback()
  },
  /**
   * 获取已拔掉的牙齿的id list
   * @returns toothid list
   */
  getExtractedToothList() {
    if (!wasmModule.isFinishedOpencase) return []
    return getArrayFromCPlusArray<number>(
      wasmModule.statusController.GetCurrentDisplayArchPulloutToothIDsNumberInfo(),
    )
  },
  /**
   *  显示/隐藏Superimpose功能
   * @param isEnabled
   * @returns
   */
  showSingleSuperImpose(isShow: boolean) {
    const moveToothModule = wasmModule.wrapInstance.GetMoveToothModule()
    moveToothModule.ShowSingleSuperImpose(isShow)
  },
  /**
   * 如果有选中牙齿，取消选中
   * @returns
   */
  cancelPickTooth() {
    if (wasmModule.wrapInstance) {
      const moveToothModule = wasmModule.wrapInstance.GetMoveToothModule()
      moveToothModule.CancelPickTooth()
    }
  },
  /**
   *  set callback for moving molar.
   *  点击 molar 牙齿的回调
   */
  setCallbackForMovingMolar(callback) {
    setToothMoveForbidCB(callback)
  },
  /**
   * set callback which invoke on tooth moving out of range.
   * 设置移动牙齿超出范围后的回调
   * @param callback
   */
  setCallbackOutOfRange(callback: () => void) {
    setMoveToothLimitCB(callback)
  },
  /**
   * set callback when modify the tooth  show modifybutton or not
   *  点击牙齿是否显示 ModificationCompleted 按钮的回调
   */
  setCallbackModifyTooth(callback: (isShow: boolean) => void) {
    setShowModificationButtonCB(callback)
  },
  /**
   *  ModificationCompleted clicked
   *
   * ModificationCompleted 按钮点击之后调用
   * 点击modificationCompleted后调用此方法
   * 此方法先预计算，判断当前case是否是simple-case,并且modify后会变成mediumcase.
   * 如果是则会调用回调‘ifSimpleCaseChangeToMediumCaseCallback’ 通知前端弹框提示
   * 如果不是则直接走 Modifycation计算。
   * 计算完成后会调用回调 finishedCallback
   *
   * if user select no then use the algorithm which keep case is simple ,else use the one which change case to medium.
   *
   * param finishedCallback
   *       ifSimpleCaseChangeToMediumCaseCallback
   */
  modifyButtonClicked(callback: () => void, popupCallback: () => void) {
    if (!wasmModule.isFinishedOpencase) return
    onModificationClicked(callback, popupCallback)
  },

  /**
   * 用户点击NO后调用的计算简单的牙齿方案
   */
  async modificationSchemeSimple() {
    modificationLogic(false)
    // true 变为简单
    const showType = displayModule.getShowType()
    viewControlInTreatment.showArchMode("all")
    viewControlInTreatment.showArchMode(showType)

    resetCaseType(ESetupType.COPASimple)
  },

  /**
   * 用户点击YES后调用的中等的牙齿方案
   */
  async modificationSchemeSecondary() {
    // false  变为中等
    modificationLogic(true)
    const showType = displayModule.getShowType()
    viewControlInTreatment.showArchMode("all")
    viewControlInTreatment.showArchMode(showType)

    resetCaseType(ESetupType.COPAModerate)
  },
  /**
   * 设置不允许牙齿移动的回调窗口
   /
   */
  setCallbackCannotMoveTooth(callback: () => void) {
    setToothClickedInViewModeCB(callback)
  },

  /**
   *  设置 显示 toothmovement信息的回调窗口
   */
  setCallbackShowToothInfo(callback: (panelDataP: PanelDataProps) => void) {
    setShowToothInfoDialogCB(callback)
  },
  /**
   * 设置是否可以移牙
   * bReadonly :true  不可移  false :可以移
   */
  setToothReadonly(bReadonly: boolean) {
    setReadonly(bReadonly)
    if (!wasmModule.isFinishedOpencase) return false
    const moveToothModule = wasmModule.wrapInstance.GetMoveToothModule()
    if (moveToothModule) {
      moveToothModule.SetViewMode(bReadonly)
    }
  },
  /**
   * 点击Setup面板中控制牙齿移动的按钮
   * Click the toothmovement buttons in setup panel
   * @param dir
   * @param quick
   * @returns
   */
  disPatchButton(dir: EToothDirection, quick: boolean) {
    disPatchButton(dir, quick)
  },
  /**
   * 设置移牙panel的root切换
   * @param isRoot
   * @returns
   */
  setRootControl(isRoot) {
    setRootControl(isRoot)
  },
  /**
   * 根据面板输入值改变牙齿movement
   * @param val 输入框中的值
   * @param dir 输入框代表的牙齿方向
   * @returns
   */
  moveWithInputValue: (val: number, dir: TypeInNumber) => {
    if (!wasmModule.isFinishedOpencase) return false
    moveWithInputValue(val, dir)
  },
  /**
   * 关闭ArchAdjustment
   * @returns
   */
  closeArchAdjustment: () => {
    if (!wasmModule.isFinishedOpencase) return
    wasmModule.moduleManager.SwitchModuleFastSmartCircle(false)
    wasmModule.moduleManager.SwitchModuleFineTuneCircle(false)
  },
  switchModuleFastSmartCircle: (onOff: boolean) => {
    if (!wasmModule.isFinishedOpencase) return
    if (onOff) wasmModule.moduleManager.SwitchModuleFineTuneCircle(false)
    wasmModule.moduleManager.SwitchModuleFastSmartCircle(onOff)
  },
  switchModuleFineTuneCircle: (onOff: boolean) => {
    if (!wasmModule.isFinishedOpencase) return
    if (onOff) wasmModule.moduleManager.SwitchModuleFastSmartCircle(false)
    wasmModule.moduleManager.SwitchModuleFineTuneCircle(onOff)
  },
  /**
   *  设置 显示prompt 如果用户正在移动不在最终阶段的牙齿
   */
  setPromptForMovingToothNotOnFinalStageCB(callback: () => void) {
    setPromptForMovingToothNotOnFinalStageCB(callback)
  },
  setPromptForMovingToothNotOnFinalStageCBResult(result: boolean) {
    if (!wasmModule.isFinishedOpencase) return false
    const moveToothModule = wasmModule.wrapInstance.GetMoveToothModule()
    if (moveToothModule) {
      moveToothModule.SetNoFinalStageMoveCBResult(result)
    }
  },
}

export const itoothModule = {
  /**
   * 查询牙齿属性
   * export interface IToothProperty {
      isCrown: boolean;
      isImplant: boolean;
      isBridge: boolean;
      isPontic: boolean;
      isExtract: boolean;
      isErupting: boolean;
      isPrimary: boolean;
    }
   * @returns
   */
  getToothProperties(toothId: number) {
    if (!wasmModule.wrapInstance) {
      console.warn("cant find wasmModule.wrapInstance, wasmModule need init.")
      return null
    }

    return toothModule.getToothProperties(toothId)
  },
  /**
   * 获取已有牙齿牙号列表（不包括missing,包括其他特殊牙齿和拔牙）
   * @returns
   */
  getToothList() {
    return toothModule.getToothList()
  },
  /**
   * 通过牙齿ID 获取Primary牙齿标识(a,b,c,d,e),
   * 前提这颗牙应该是Primiry牙齿，ID范围是5XX，否则返回 undefined
   * @param toothId
   * @returns
   */
  getPrimaryToothMark(toothId: number) {
    return toothModule.getPrimaryToothMark(toothId)
  },
}

/**
 * Interfaces of history actions
 */
export const history = {
  /**
   * undo one step
   * @returns
   */
  undo() {
    if (!wasmModule.isFinishedOpencase) return false
    const module = wasmModule.ulabwinIns.getModuleManager()
    if (module) {
      module.GetUndoOrRedoModule().GetLastState()
    }
    // close panel
    disPatchPanelDataCallback()
    return true
  },

  /**
   * redo one step
   * @returns
   */
  redo() {
    if (!wasmModule.isFinishedOpencase) return false
    const module = wasmModule.ulabwinIns.getModuleManager()
    if (module) {
      module.GetUndoOrRedoModule().GetNextState()
    }
    // close panel
    disPatchPanelDataCallback()
    return true
  },

  /**
   * clear all steps
   * @returns
   */
  clearAll() {
    if (!wasmModule.isFinishedOpencase) return false
    const module = wasmModule.ulabwinIns.getStageContoller()
    // const undo = undefined;
    if (module) {
      caseManagement.getAttachmentIPRData()
      module.ResetAutoSetUpResult()
      clearUndoOrRedoState()

      toothMoveEvent.fire(EToothMoveEventType.RESETCLICKED_EVENT)
      // close panel
      disPatchPanelDataCallback()
    }
    return true
  },
}

export const viewEdit = {
  /**
   * view <-> edit switch
   * @param isToEdit
   * @returns void
   */
  switchViewToEdit(isEdit: boolean) {
    if (!wasmModule.isFinishedOpencase) return 0
    //stagingManager.setEndNodeIndex()
    return wasmModule.statusController.SwitchViewAndEdit(isEdit)
  },
}

export const refinement = {
  /**
   * open history display module
   * @param isOpen
   */
  openRefinementModule(isOpen: boolean) {
    return refinementModule.openRefinementModule(isOpen)
  },
  /**
   * set Refinement Display Range
   * @param displayRange (all/original/refinement1/refinement2/...)
   * @returns
   */
  setRefinementDisplayRange(displayRange: string) {
    return refinementModule.setRefinementDisplayRange(displayRange)
  },
  /**
   * get Refinement Info
   * @param archType
   * @returns
   */
  getRefinementInfo(archType: number) {
    return refinementModule.getRefinementInfo(archType)
  },
  /**
   * get refinement history list
   * @returns
   */
  getRefinementDataInfo() {
    return refinementModule.getRefinementDateInfo()
  },
  /**
   * change Display Stage Value
   */
  changeDisplayStageValue(index: number, archType: number) {
    refinementModule.changeDisplayStageValue(index, archType)
  },
  /**
   * get Number Of Refinement
   * @param archType
   * @returns
   */
  getNumberOfRefinement(archType: number) {
    return refinementModule.getNumberOfRefinement(archType)
  },
  /**
   * undo refinement
   * @returns
   */
  undoRefinement() {
    refinementModule.undoRefinement()
  },
  /**
   * save case data as history
   * @returns
   */
  saveNewHistoryData() {
    refinementModule.saveNewHistoryData()
  },

  getRefinementToothProperties(toothId: number) {
    return refinementModule.getRefinementToothProperties(toothId)
  },

  getRefinementToothList() {
    return refinementModule.getRefinementToothList()
  },

  getLastRefinementName() {
    return refinementModule.getLastRefinementName()
  },
}

export const relabel = {
  /**
   * open or close relabel module
   * @param isOpen
   * @returns
   */
  openRelabelModule(isOpen: boolean) {
    relabelModule.openRelabelModule(isOpen)
  },
  /**
   * have same label, or not
   * @returns
   */
  IsExistSameLabel() {
    return relabelModule.IsExistSameLabel()
  },
  /**
   * reset label
   * @returns
   */
  ResetLabel(archType: number) {
    relabelModule.ResetLabel(archType)
  },
  /**
   * manual label
   * @param bManualModel
   * @returns
   */
  GotoManualModel(bManualModel: boolean, archType: number) {
    relabelModule.GotoManualModel(bManualModel, archType)
  },
  /**
   * relabel module open or not
   * @returns
   */
  IsRelabelModuleOpened() {
    return relabelModule.IsRelabelModuleOpened()
  },
  /**
   * have same label for single jaw, or not
   * @param archType
   * @returns
   */
  IsExistSameLabelForSingleJaw(archType: number) {
    return relabelModule.IsExistSameLabelForSingleJaw(archType)
  },
  /**
   * stage show type(normal)
   * @param callback
   * @returns
   */
  setstageShowTypeNormalCallback(callback: () => void) {
    wasmModule.stageShowTypeNormalCallback = callback
  },
  /**
   * Get the zoom value in the Relabel module from wasm
   * @param callback
   * @returns
   */
  SetRelabelUpdateZoomCB(callback: any) {
    relabelModule.setZoomCallback(callback)
  },
  /**
   * set zoom value
   * @param zoomValue
   * @returns
   */
  SetZoomValue(zoomValue: number) {
    relabelModule.SetZoomValue(zoomValue)
  },
  /**
   * set zoom value
   * @param zoomValueForPicker
   * @returns
   */
  SetZoomValueForPicker(zoomValueForPicker: number) {
    relabelModule.SetZoomValueForPicker(zoomValueForPicker)
  },
}

export const orderView = {
  /**
   * 设置order流程WASM窗口分页
   * @param isSplit 是否分页
   */
  splitPageForOrder(isSplit: boolean) {
    console.log("setupPageForOrder")
    if (isSplit) {
      wasmModule.statusController.ResizeRenderer(0.4)
    } else {
      wasmModule.statusController.ResizeRenderer(1.0)
    }
  },
  /**
   * 获取Elastic 附件 json信息,返回的是json的字符串内容
   * @param teethIdArray scanbutton中选中的牙齿ID列表[1-32]
   */
  getElasticJson(teethIdArray: number[]): string {
    return attachmentModule.getElasticJsonContent(teethIdArray)
  },
  /**
   * 保存elastic json文件
   * @param toothIds
   * @returns
   */
  saveElasticJsonFile(teethIdArray: number[]) {
    attachmentModule.saveElasticJsonFile(teethIdArray)
  },
  /**
   * 进入aligner coverage页面需要调用此方法初始化窗口
   * @returns
   */
  initAlignerCoverageViewInOrderPage(bgcolor: [number, number, number]) {
    caseManagement.setBackgroundColor(bgcolor[0], bgcolor[1], bgcolor[2])
    wasmModule.stagingcontoler.OpenOrClosetoothMoveModule(false)
    wasmModule.moduleManager.SwitchModuleSelectToothInOrder(false)
  },
  /**
   * 离开scanbutton页面
   */
  exitOrderScanbuttonStatus() {
    // 清理选中的button flag
    const toothInOrderModule =
      wasmModule.moduleManager.GetModuleSelectToothInOrder()
    toothInOrderModule.clearAllSelectedTooth()
    wasmModule.moduleManager.SwitchModuleSelectToothInOrder(false)
  },
  /**
   * 初始化和清理order选牙3D窗口
   * @param bgcolor 3D窗口背景颜色
   * @returns
   */
  initAndClearOrderView(
    bgcolor: [number, number, number],
    isScanedButton: boolean = false,
  ) {
    caseManagement.setBackgroundColor(bgcolor[0], bgcolor[1], bgcolor[2])
    wasmModule.stagingcontoler.OpenOrClosetoothMoveModule(false)
    wasmModule.moduleManager.SwitchModuleSelectToothInOrder(false)
    wasmModule.moduleManager.SwitchModuleSelectToothInOrder(true)

    // if it's scaned button mode, set the feature in toothInOrderModule.
    if (isScanedButton) {
      const toothInOrderModule =
        wasmModule.moduleManager.GetModuleSelectToothInOrder()
      toothInOrderModule.setFeatureOfScannedButtons(true)
    }
  },
  /**
   * 设置选中牙齿的颜色
   * @param toothSelectedColor 选中牙齿颜色
   * @returns
   */
  setTeethSelectedColor(toothSelectedColor: [number, number, number]) {
    const toothInOrderModule =
      wasmModule.moduleManager.GetModuleSelectToothInOrder()
    toothInOrderModule.setPickedToothColor(
      toothSelectedColor[0],
      toothSelectedColor[1],
      toothSelectedColor[2],
    )
  },
  /**
   * 设置默认选中的牙齿
   * @param toothIds 牙齿ID （1-32）
   * @returns
   */
  setDefaultTeethSelected(toothIds: number[]) {
    const toothInOrderModule =
      wasmModule.moduleManager.GetModuleSelectToothInOrder()
    for (let index = 0; index < toothIds.length; index++) {
      const toothId = toothIds[index]
      console.log("setDefaultTeethSelected", toothId)
      toothInOrderModule.setPickedTooth(toothId)
    }
  },
  /**
   * 获取List of 选中的牙齿ID
   * @returns
   */
  getTeethSelected() {
    const toothInOrderModule =
      wasmModule.moduleManager.GetModuleSelectToothInOrder()
    const teethIdCArray = toothInOrderModule.getSelectedToothIds()
    const teethIds = getArrayFromCPlusArray<number>(teethIdCArray)
    return teethIds
  },
}

export const biteRampModule = {
  /**
   * 打开/关闭BiteRamp界面功能
   * @param enable
   * @returns
   */
  setOperationEnable(enable: boolean): void {
    if (!wasmModule.isFinishedOpencase) return
    wasmModule.moduleManager.GetBiteRampModule().SetOperationEnable(enable)
  },
  /**
   * 控制是否显示height面板
   * @param enable
   * @returns
   */
  SetPlaneVisiable(enable: boolean): void {
    if (!wasmModule.isFinishedOpencase) return
    wasmModule.moduleManager.GetBiteRampModule().SetPlaneVisiable(enable)
  },
  /**
   * 对6-11号牙齿添加biteramp
   * @param toothID 6-11
   * @returns 添加失败会返回false
   */
  autoAddBiteRampToTooth(toothID: number): boolean {
    if (!wasmModule.isFinishedOpencase) return false
    const isAdd = wasmModule.moduleManager
      .GetBiteRampModule()
      .AutoAddBiteRampToTooth(toothID)
    globalEvents.fire(GlobalEvents.ON_REPORT_UPDATE)
    return isAdd
  },
  /**
   * 取消打勾，删除牙齿上的bite ramp
   * @param toothID 6-11
   * @returns
   */
  deleteBiteRamp(toothID: number): void {
    if (!wasmModule.isFinishedOpencase) return
    wasmModule.moduleManager.GetBiteRampModule().DeleteBiteRamp(toothID)
    globalEvents.fire(GlobalEvents.ON_REPORT_UPDATE)
  },
  /**
   * 获取牙齿是否添加了biteramp
   * @param toothid 6-11
   * @returns
   */
  isToothHasBiteRamp(toothid: number): boolean {
    if (!wasmModule.isFinishedOpencase) return false
    const biteRampModule = wasmModule.moduleManager.GetBiteRampModule()
    if (!biteRampModule) return false
    const isHas = biteRampModule.IsToothHasBiteRamp(toothid)
    return isHas
  },
  /**
   * Get whether the upper or lower jaw has added a biteramp
   * @param isUpper
   * @returns
   */
  isHaveBiteRampOnArch(isUpper): boolean {
    if (!wasmModule.isFinishedOpencase) return false

    const archType = isUpper
      ? wasmModule.module.ArchType.UpArch
      : wasmModule.module.ArchType.DownArch
    return wasmModule.statusController.IsHaveBiteRampOnArch(archType)
  },
  /**
   * 设置biteramp开始显示的stage
   * @param startStage startStage必须小于endStage
   * @returns
   */
  changeStartStage(startStage: number): void {
    if (!wasmModule.isFinishedOpencase) return
    wasmModule.moduleManager.GetBiteRampModule().ChangeStartStage(startStage)
  },
  /**
   * 设置biteramp结束显示的stage
   * @param endStage
   * @returns startStage必须小于endStage
   */
  changeEndStage(endStage: number): void {
    if (!wasmModule.isFinishedOpencase) return
    wasmModule.moduleManager.GetBiteRampModule().ChangeEndStage(endStage)
  },
  /**
   * 获取biteramp开始显示的stage
   * @returns
   */
  getStartStage(): number {
    if (!wasmModule.isFinishedOpencase) return -1

    const startStage = wasmModule.moduleManager
      .GetBiteRampModule()
      .GetStartStage(wasmModule.module.ArchType.BothArch)

    return startStage
  },
  /**
   * 获取biteramp结束显示的stage
   * @returns
   */
  getEndStage(): number {
    if (!wasmModule.isFinishedOpencase) return -1

    const endStage = wasmModule.moduleManager
      .GetBiteRampModule()
      .GetEndStage(wasmModule.module.ArchType.BothArch)

    return endStage
  },
  /**
   * 设置biteramp的显示/隐藏
   * @param bVisiable
   * @returns
   */
  setBiteRampVisiable(bVisiable: boolean): void {
    if (!wasmModule.isFinishedOpencase) return
    wasmModule.moduleManager.GetBiteRampModule().SetBiteRampVisiable(bVisiable)
  },
  /**
   * 同步牙齿高度到面板
   * @returns
   */
  syncBiteRampHeightToPlane(): void {
    if (!wasmModule.isFinishedOpencase) return
    wasmModule.moduleManager.GetBiteRampModule().SyncBiteRampHeightToPlane()
  },
  /**
   * 显示/隐藏一个三颗牙齿的下颌,默认隐藏
   * @param visible
   * @returns
   */
  onShowDownTeethIn3to3Range(visible) {
    if (!wasmModule.isFinishedOpencase) return
    wasmModule.moduleManager.GetBiteRampModule().ShowOppositeOverlay(visible)
  },
  /**
   * 绑定按钮显示位置回调
   * @param callback  x mines left , y mines bottom in css
   * @returns
   */
  onButtonPosChangeCallback(callback) {
    const windowObj = window as any
    windowObj.OnBiteRampBtnPosChange = callback
  },
}

export const treatView = {
  /**
   * ???
   * @param onOff
   */
  Open(onOff: boolean): void {
    if (onOff) {
      wasmModule.moduleManager.SetModuleMoveToothInteroperable(!onOff)
      wasmModule.moduleManager.SwitchModuleTreatView(onOff)
    } else {
      wasmModule.moduleManager.SwitchModuleTreatView(onOff)
      wasmModule.moduleManager.SetModuleMoveToothInteroperable(!onOff)
    }
  },
  /**
   * start split screen to create refinement.
   * @returns
   */
  startSplitScreenToCreateRefinement() {
    treatView.Open(true)
    wasmModule.treatView?.Start()
  },
  /**
   * compare for txs, start compare
   */
  StartComparison(leftTreatName: string, rightTreatName: string): boolean {
    return wasmModule.treatView?.StartComparison(leftTreatName, rightTreatName)
  },
  /**
   * compare for refinement
   * @param leftTreatName
   * @param rightTreatName
   * @returns
   */
  RefinementHistory(leftTreatName: string): boolean {
    return wasmModule.treatView?.RefinementHistory(leftTreatName)
  },
  /**
   * set background picture for compare view
   * @param viewId left: 0  right: 1
   * @param picture picture name
   * @returns
   */
  SetBackgroundPicture(id, picture) {
    return wasmModule.treatView?.SetBackgroundPicture(id, picture)
  },
  /**
   * switch refinement history left view when compare open
   * @param leftTreatName
   * @returns
   */
  SwitchRefinementHistory(leftTreatName: string) {
    return wasmModule.treatView?.SwitchRefinementHistory(leftTreatName)
  },
  /**
   * switch the tx plan for compare
   */
  SwitchTxPlan(viewId: number, planIndex: number): boolean {
    return wasmModule.treatView?.SwitchTxPlan(viewId, planIndex)
  },
  /**
   * compare for txs, get compare nodes
   */
  GetNodes(viewId: number, archIndex: number): any {
    return wasmModule.treatView?.GetNodes(viewId, archIndex)
  },
  /**
   * compare for txs, start play
   */
  PlayFrame(viewId: number, stageIndex: number): void {
    wasmModule.treatView?.PlayFrame(viewId, stageIndex)
  },
  /**
   * compare for txs, get refinement data
   */
  GetHistoryDataInfo(viewId: number, archIndex: number): any {
    const historyStr = wasmModule.treatView?.GetHistoryDataInfo(
      viewId,
      archIndex,
    )
    const historyArray: string[] = historyStr.split(";")
    return historyArray
  },
  /**
   * Get the zoom value in the current refinementview from wasm
   * @param callback
   * @returns
   */
  SetUpdateSliderCB(callback: any): void {
    if (!wasmModule.isFinishedOpencase) return

    wasmModule.treatView?.SetMinScaleValue(0.25)
    wasmModule.treatView?.SetMaxScaleValue(4)

    if (!(window as any).treatment) {
      ;(window as any).treatment = {}
    }
    ;(window as any).treatment.refinementViewZoomCallback = callback

    wasmModule.treatView?.SetUpdateSliderCB(
      "treatment.refinementViewZoomCallback",
    )
  },
  /**
   * Get the view gm's enable
   * @param viewID
   * @returns
   */
  IsHaveGM(viewID: number): boolean {
    return wasmModule.treatView?.IsHaveGM(viewID)
  },
  /**
   * Play gm
   * @param viewID
   * @returns
   */
  PlayGM(viewID: number): number {
    return wasmModule.treatView?.PlayGM(viewID)
  },

  /**
   * Set gm to final
   * @param viewID
   * @returns
   */
  SetGMToFinal(viewID: number): void {
    return wasmModule.treatView?.SetGMToFinal(viewID)
  },

  /**
   * Set GM Type
   * @param viewID
   * @param type
   * @returns
   */
  SetBiteJumType(viewID: number, type: number): void {
    return wasmModule.treatView?.SetBiteJumType(viewID, type)
  },

  /**
   * Update LowerArch Actor After Set GM Type
   * @param viewID
   * @returns
   */
  UpdateLowerArchActorAfterSetGMType(viewID: number): void {
    return wasmModule.treatView?.UpdateLowerArchActorAfterSetGMType(viewID)
  },
}

export const spaceCorrection = {
  /**
   * open space correction module
   * @param isOpen
   */
  openSpaceCorrectionModule(isOpen: boolean) {
    spaceCorrectionModule.openSpaceCorrectionModule(isOpen)
  },
  /**
   * Get the zoom value in the current space correction from wasm
   * @param callback
   * @returns
   */
  SetUpdateZoomCB(callback: any) {
    spaceCorrectionModule.setZoomCallback(callback)
  },

  saveData() {
    spaceCorrectionModule.saveData()
  },

  pendingApplyEditValue() {
    spaceCorrectionModule.pendingApplyEditValue()
  },

  setApplyStatusCallback(callback: (isPending: number) => void) {
    spaceCorrectionModule.setApplyStatusCallback = (isPending: number) => {
      if (callback) {
        callback(isPending)
      }
    }
  },
}

export const stagingIPR = {
  /**
   * open Staging IPR module
   * @param isOpen
   */
  switchStagingIPRModule(isOpen: boolean) {
    stagingIPRModule.switchStagingIPRModule(isOpen)
  },
  /**
   * add new IPR node
   * @param archType
   * @param stageIndex
   * @returns
   */
  addNewIPRNode(archType: number, stageIndex: number) {
    return stagingIPRModule.addNewIPRNode(archType, stageIndex)
  },
  /**
   * remove IPR node
   * @param archType
   * @param stageIndex
   */
  removeIPRNode(archType: number, stageIndex: number) {
    stagingIPRModule.removeIPRNode(archType, stageIndex)
  },
  /**
   * move IPR node
   * @param archType
   * @param orgStageIndex
   * @param tarStageIndex
   */
  moveIPRNode(archType: number, orgStageIndex: number, tarStageIndex: number) {
    stagingIPRModule.moveIPRNode(archType, orgStageIndex, tarStageIndex)
  },
  /**
   * get all collision stage
   * @param archType
   * @returns
   */
  getCollisionStage(archType: number) {
    return stagingIPRModule.getCollisionStage(archType)
  },

  checkRemainingIPR(): string {
    return stagingIPRModule.checkRemainingIPR()
  },

  checkNullIPRNodes(): string {
    return stagingIPRModule.checkNullIPRNodes()
  },

  removeNullIprNodes() {
    return stagingIPRModule.removeNullIprNodes()
  },

  setNumberingSys(numberingSys: string) {
    return stagingIPRModule.setNumberingSys(numberingSys)
  },
}
